<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!sectorSelected) {
        <h1 class="title">Crear {{ termKey.SectorSingular | term }}</h1>
      }
    </div>
    <div class="title-color">
      @if (sectorSelected) {
        <h1 class="title">Editar {{ termKey.SectorSingular | term }}</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="sectorForm" (ngSubmit)="saveSector()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (sectorForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (sectorForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Objetivo</mat-label>
              <textarea
                matInput
                placeholder="Objetivo"
                formControlName="objective"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
              @if (sectorForm.get('objective')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Riesgo</mat-label>
              <input
                type="text"
                matInput
                placeholder="Riesgo"
                formControlName="risk"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (sectorForm.get('risk')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (sectorForm.get('risk')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <div class="search-select-container">
              <app-search-select
                [dataList]="componentSelected"
                [initialValue]="getComponentValue()"
                placeholder="Componente"
                label="Componente"
                noResults="Sin resultados"
                (onSelectOption)="onComponentSelected($event)"
              >
              </app-search-select>
            </div>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!sectorForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
